package org.example.project.dashboard

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonElement

@Serializable
data class ResourceChangeEvent(
    val group: String = "",
    val resourceType: String = "",
    val resourceId: String = "",
    val companyId: String = "",
    val data: JsonElement? = null
)

object ResourceSyncRegistry {
    private val handlers = mutableMapOf<String, (ResourceChangeEvent) -> Unit>()

    fun register(key: String, handler: (ResourceChangeEvent) -> Unit) {
        handlers[key] = handler
    }

    fun unregister(key: String) {
        handlers.remove(key)
    }

    fun dispatch(event: ResourceChangeEvent) {
        handlers.values.forEach { it(event) }
    }
}

@Composable
fun RegisterResourceSyncHandler(key: String, handler: (ResourceChangeEvent) -> Unit) {
    DisposableEffect(key, handler) {
        ResourceSyncRegistry.register(key, handler)
        onDispose {
            ResourceSyncRegistry.unregister(key)
        }
    }
}
